var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { directives: [{ name: "masonry", rawName: "v-masonry" }] },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", lg: "4" } },
            [
              _c(
                "v-card",
                { staticClass: "soli-round" },
                [
                  _c(
                    "v-container",
                    [
                      _c("v-card-title", { staticClass: "soli-grey" }, [
                        _vm._v(
                          "\n                        Relationships\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-subtitle",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "soli-round soli-blue-text",
                              attrs: {
                                disabled:
                                  !_vm.user.email &&
                                  !_vm.relationships.find((e) => e.email),
                                "x-small": "",
                                outlined: "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.relationshipForm = true
                                },
                              },
                            },
                            [_vm._v("Add Relationship")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        [
                          _c("UserRelationships", {
                            attrs: {
                              user: _vm.user,
                              relationships: _vm.relationships,
                              sharedSubscriptions: _vm.sharedSubscriptions,
                            },
                            on: {
                              change: _vm.redrawVueMasonry,
                              success: function ($event) {
                                return _vm.$emit("success")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", lg: "4" } },
            [
              _c(
                "v-card",
                { staticClass: "soli-round" },
                [
                  _c(
                    "v-container",
                    [
                      _c("v-card-title", { staticClass: "soli-grey" }, [
                        _vm._v(
                          "\n                        Passes and Memberships\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-subtitle",
                        [
                          _vm.can("Work") &&
                          _vm.$page.props.staffView &&
                          !!_vm.user.email
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "soli-round soli-blue-text",
                                  attrs: { "x-small": "", outlined: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.user.email
                                        ? _vm.visitStore()
                                        : (_vm.showEmailAlert = "purchase")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            Make a Purchase\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("UserSubscription", {
                        key: _vm.refreshTransactions,
                        attrs: {
                          user: _vm.user,
                          sharedSubscriptions: _vm.sharedSubscriptions,
                          relationships: _vm.relationships,
                          errors: _vm.errors,
                        },
                        on: {
                          change: _vm.redrawVueMasonry,
                          success: function ($event) {
                            ;[_vm.$emit("success"), _vm.refreshTransactions++]
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          (_vm.user.id == _vm.$page.props.auth.user.id ||
            _vm.$page.props.staffView) &&
          !!_vm.user.email
            ? _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", lg: "4" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "soli-round" },
                    [
                      _c(
                        "v-container",
                        [
                          _c("v-card-title", { staticClass: "soli-grey" }, [
                            _vm._v(
                              "\n                        Billing\n                        "
                            ),
                            _vm.user.defaultPaymentMethod
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ml-3 align-center flex caption",
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "soli-blue-text",
                                        attrs: { small: "" },
                                      },
                                      [_vm._v("credit_card")]
                                    ),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          `${_vm.user.defaultPaymentMethod.brand}${_vm.user.defaultPaymentMethod.last4}`
                                        ) +
                                        "\n                        "
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm.user.stripe_id
                            ? _c(
                                "v-card-subtitle",
                                [
                                  _vm.can("Issue refunds and credits") &&
                                  _vm.$page.props.staffView &&
                                  _vm.billingLoaded
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "soli-round soli-blue-text",
                                          attrs: {
                                            "x-small": "",
                                            outlined: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.$refs.transactions.showCreditForm = true
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                            Adjust Balance\n                        "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.billingLoaded
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "soli-round soli-blue-text",
                                          attrs: {
                                            "x-small": "",
                                            outlined: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.visitBillingPortal()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                            Payment Methods"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.can("Work") && _vm.$page.props.staffView
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "soli-round soli-blue-text",
                                          attrs: {
                                            "x-small": "",
                                            outlined: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.user.email
                                                ? (_vm.$refs.transactions.showGiftForm = true)
                                                : (_vm.showEmailAlert =
                                                    "purchase")
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                            Redeem Code\n                        "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c(
                                "v-card-subtitle",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "soli-round soli-blue-text",
                                      attrs: { "x-small": "", outlined: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.user.email
                                            ? _vm.addCreditCard()
                                            : (_vm.showEmailAlert = "billing")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Add Payment Method"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _vm.user.stripe_id
                            ? _c("UserTransactions", {
                                key: _vm.refreshTransactions,
                                ref: "transactions",
                                attrs: { user: _vm.user, errors: _vm.errors },
                                on: {
                                  change: _vm.redrawVueMasonry,
                                  "hook:updated": _vm.redrawVueMasonry,
                                  success: function ($event) {
                                    return _vm.$emit("success")
                                  },
                                  billingLoaded: function ($event) {
                                    _vm.billingLoaded = $event
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.enrollmentHistory.length && _vm.$page.props.auth.staffView
            ? _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", lg: "4" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "soli-round" },
                    [
                      _c(
                        "v-container",
                        [
                          _c("v-card-title", { staticClass: "soli-grey" }, [
                            _vm._v(
                              "\n                        Enrollment History\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-container",
                            [
                              _c("UserEnrollmentHistory", {
                                attrs: {
                                  user: _vm.user,
                                  enrollmentHistory: _vm.enrollmentHistory,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.relationshipForm
        ? _c("ManageRelationships", {
            attrs: { user: _vm.user, relationships: _vm.relationships },
            on: {
              success: function ($event) {
                ;[
                  _vm.$emit("success"),
                  _vm.closeModal(() => (_vm.relationshipForm = false)),
                ]
              },
              reset: function ($event) {
                _vm.relationshipForm = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showEmailAlert
        ? _c("SoliChoice", {
            attrs: {
              button1: "Okay",
              title: "Error",
              subtitle: `User must have an email address to ${
                _vm.showEmailAlert == "purchase"
                  ? "make a purchase"
                  : _vm.showEmailAlert == "billing"
                  ? "enable billing"
                  : "redeem a gift certificate"
              }`,
            },
            on: {
              reset: function ($event) {
                _vm.showEmailAlert = null
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }